export const isOnUnauthenticatedRoute = (path) => {
  return /(^\/$)|(^\/login)|(^\/signup)|(^\/reset-password)|(^\/forgot)|(^\/online-payment)/.test(path);
};

export const isOnMainRoute = (path) => {
  return path.indexOf('/main') === 0;
};
